import { styled } from '../muiReexports';
import { dialogTitleCaptionLineHeight } from './constants';
export const DialogTitleCaption = styled('span')(({ theme }) => ({
    fontSize: theme.typography.h4.fontSize,
    fontWeight: theme.typography.h4.fontWeight,
    lineHeight: dialogTitleCaptionLineHeight,
}));
